import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock } from 'lucide-react';
import { trackEvent } from '../utils/pixel';
export function CtaSection() {
  return <section id="cta" className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden bg-brand-dark" data-id="element-9">
      {/* Background gradient for emphasis */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-brand-accent/5 pointer-events-none" data-id="element-10" />

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-brand-card p-8 sm:p-12 rounded-3xl border border-brand-accent/20 shadow-2xl shadow-brand-accent/5" data-id="element-12">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-white mb-8 leading-tight" data-id="element-13">
            Toma el control de tu dinero hoy mismo.
          </h2>

          <p className="text-sm text-brand-accent font-medium mb-3" data-id="element-14">
            Oferta de lanzamiento:{' '}
            <span className="font-bold" data-id="element-15">75% de descuento</span> solo por esta
            semana{' '}
            <span className="line-through text-slate-400" data-id="element-16">
              (Precio regular $47)
            </span>
          </p>

          <a href="https://pay.hotmart.com/I105228978B" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('AddToCart', {
          content_name: 'Método George Capital Coaching',
          value: 6.36,
          currency: 'USD'
        })} className="group relative inline-flex flex-col sm:flex-row items-center justify-center gap-3 bg-brand-accent text-brand-dark w-full sm:w-auto px-8 py-5 rounded-xl font-bold text-lg sm:text-xl hover:bg-brand-accentHover transition-all hover:scale-105 active:scale-95 shadow-[0_0_40px_-10px_rgba(245,158,11,0.4)]" data-id="element-17">
            <span className="text-center" data-id="element-18">
              SÍ, QUIERO EL MÉTODO POR SÓLO $11.36 USD
            </span>
            <span className="hidden sm:inline" data-id="element-19">—</span>
            <span className="flex items-center gap-2" data-id="element-20">
              ACCESO INMEDIATO
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-21" />
            </span>
          </a>

          <div className="mt-8 flex flex-col items-center gap-3 text-slate-400 text-sm" data-id="element-22">
            <div className="flex items-center gap-2" data-id="element-23">
              <Lock className="w-4 h-4" data-id="element-24" />
              <span data-id="element-25">Pago 100% seguro y encriptado</span>
            </div>
            <p data-id="element-26">Oferta por tiempo limitado. Acceso de por vida al material.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}